import dayjs from 'dayjs';

export const dummyorderStatusChartByDate = [
  {
    date: '8-Aug-2024',
    SUBMITTED: 4,
    CANCELED: 1,
    PROGRESS: 2,
    Pending: 3,
  },
  {
    date: '10-Aug-2024',
    SUBMITTED: 1,
    CANCELED: 0,
    PROGRESS: 1,
    Pending: 1,
  },
  {
    date: '14-Aug-2024',
    SUBMITTED: 4,
    CANCELED: 2,
    PROGRESS: 3,
    Pending: 2,
  },
  {
    date: '17-Aug-2024',
    SUBMITTED: 2,
    CANCELED: 1,
    PROGRESS: 1,
    Pending: 2,
  },
  {
    date: '21-Aug-2024',
    SUBMITTED: 2,
    CANCELED: 1,
    PROGRESS: 1,
    Pending: 1,
  },
  {
    date: '11-Oct-2024',
    SUBMITTED: 3,
    CANCELED: 0,
    PROGRESS: 2,
    Pending: 1,
  },
  {
    date: '12-Oct-2024',
    SUBMITTED: 1,
    CANCELED: 1,
    PROGRESS: 0,
    Pending: 1,
  },
  {
    date: '18-Oct-2024',
    SUBMITTED: 1,
    CANCELED: 0,
    PROGRESS: 0,
    Pending: 1,
  },
  {
    date: '21-Oct-2024',
    SUBMITTED: 1,
    CANCELED: 0,
    PROGRESS: 0,
    Pending: 1,
  },
  {
    date: '23-Oct-2024',
    SUBMITTED: 1,
    CANCELED: 0,
    PROGRESS: 1,
    Pending: 0,
  },
  {
    date: '25-Oct-2024',
    SUBMITTED: 1,
    CANCELED: 0,
    PROGRESS: 1,
    Pending: 0,
  },
  {
    date: '1-Nov-2024',
    SUBMITTED: 2,
    CANCELED: 1,
    PROGRESS: 1,
    Pending: 1,
  },
  {
    date: '15-Nov-2024',
    SUBMITTED: 1,
    CANCELED: 0,
    PROGRESS: 0,
    Pending: 1,
  },
  {
    date: '19-Nov-2024',
    SUBMITTED: 3,
    CANCELED: 1,
    PROGRESS: 2,
    Pending: 2,
  },
  {
    date: '10-Dec-2024',
    SUBMITTED: 3,
    CANCELED: 0,
    PROGRESS: 2,
    Pending: 1,
  },
  {
    date: '11-Dec-2024',
    SUBMITTED: 2,
    CANCELED: 1,
    PROGRESS: 1,
    Pending: 1,
  },
];
// const date = Object.keys(dummyorderStatusChartByDate);
const date = dummyorderStatusChartByDate?.map((order) => order?.date);
const Submitted = dummyorderStatusChartByDate?.map((order) => order?.SUBMITTED);
const Canceled = dummyorderStatusChartByDate?.map((order) => order?.CANCELED);
const Progress = dummyorderStatusChartByDate?.map((order) => order?.PROGRESS);
const Pending = dummyorderStatusChartByDate?.map((order) => order?.Pending);

export const sliderData = [
  {
    heading: 'Worry-Free Healthcare Starts Here',
    imgUrl: '/images/ladyWithKids.jpg',
    buttonText: 'Learn more',
    href: '/about-us',
  },
  {
    heading: 'Connecting hearts through healthcare',
    buttonText: 'who we are',
    imgUrl: '/images/docWithSpecs.jpg',
    href: '/about-us',
  },
  {
    heading: 'Healthcare for those that matter most',
    buttonText: 'who we are',
    imgUrl: '/images/oldLady.jpg',
    href: '/about-us',
  },
];

export function amountFormat(amount) {
  if (isNaN(amount)) return amount;
  const parsedAmount = Number(amount);
  return parsedAmount % 1 === 0 ? parsedAmount : parsedAmount?.toFixed(2);
}

const statusMapping = [
  { s_status_id: 1, s_status_cd: 'SUBMITTED' },
  { s_status_id: 2, s_status_cd: 'PAID' },
  { s_status_id: 3, s_status_cd: 'ACCEPTED' },
  { s_status_id: 4, s_status_cd: 'CONTACTED' },
  { s_status_id: 5, s_status_cd: 'UNREACHABLE' },
  { s_status_id: 6, s_status_cd: 'DECLINE' },
  { s_status_id: 7, s_status_cd: 'COMPLETED' },
  { s_status_id: 8, s_status_cd: 'EXPIRED' },
  { s_status_id: 9, s_status_cd: 'FAILED' },
  { s_status_id: 10, s_status_cd: 'CANCELLED' },
  { s_status_id: 11, s_status_cd: 'CHECK-IN' },
  { s_status_id: 12, s_status_cd: 'PAID-OUT' },
  { s_status_id: 13, s_status_cd: 'PRICED' },
  { s_status_id: 14, s_status_cd: 'PAYMNT-PENDING' },
];
export const getStatusColor = (statusId) => {
  const colors = {
    1: '#1f77b4', // SUBMITTED
    2: '#ff7f0e', // PAID
    3: '#2ca02c', // ACCEPTED
    4: '#d62728', // CONTACTED
    5: '#9467bd', // UNREACHABLE
    6: '#8c564b', // DECLINE
    7: '#e377c2', // COMPLETED
    8: '#7f7f7f', // EXPIRED
    9: '#bcbd22', // FAILED
    10: '#17becf', // CANCELLED
    11: '#aec7e8', // CHECK-IN
    12: '#ffbb78', // PAID-OUT
    13: '#98df8a', // PRICED
    14: '#ff9896', // PAYMNT-PENDING
  };

  return colors[statusId] || '#000000'; // Default to black if ID not in the map
};

export const statusByDateChartOption = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
  },
  legend: {},
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true,
  },
  xAxis: [
    {
      type: 'category',
      data: date,
    },
  ],
  yAxis: [
    {
      type: 'value',
    },
  ],
  series: [
    {
      name: 'Submitted',
      type: 'bar',
      emphasis: {
        focus: 'series',
      },
      data: Submitted,
    },
    {
      name: 'Canceled',
      type: 'bar',
      stack: 'Ad',
      emphasis: {
        focus: 'series',
      },
      data: Canceled,
    },
    {
      name: 'Progress',
      type: 'bar',
      stack: 'Ad',
      emphasis: {
        focus: 'series',
      },
      data: Progress,
    },
    {
      name: 'Pending',
      type: 'bar',
      stack: 'Ad',
      emphasis: {
        focus: 'series',
      },
      data: Pending,
    },
  ],
};

export const generateStatusByDateChartOption = (data) => {
  const statusLookup = statusMapping?.reduce((acc, status) => {
    acc[status.s_status_id] = {
      name: status.s_status_cd,
      color: getStatusColor(status.s_status_id), // Assign a color based on id
    };
    return acc;
  }, {});

  const statusKeys = Object.keys(data[0] || {}).filter((key) => key !== 'date');
  const dates = data.map((order) => order.date);

  const series = statusKeys.map((statusKey) => {
    const statusId = parseInt(statusKey, 10); // Convert key to integer for lookup
    const status = statusLookup[statusId] || {
      name: `Status ${statusKey}`,
      color: '#000000',
    };

    return {
      name: status.name, // Use status name from lookup
      type: 'bar',
      stack: 'Ad', // Grouping bars by stack
      emphasis: {
        focus: 'series',
      },
      itemStyle: {
        color: status.color, // Use color from lookup
      },
      data: data.map((order) => order[statusKey] || 0), // Map each key's data, defaulting to 0
    };
  });

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    legend: {},
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        data: dates,
      },
    ],
    yAxis: [
      {
        type: 'value',
      },
    ],
    series,
    // series: [
    //   {
    //     name: "Submitted",
    //     type: "bar",
    //     emphasis: {
    //       focus: "series",
    //     },
    //     data: submittedData,
    //   },
    //   {
    //     name: "Canceled",
    //     type: "bar",
    //     stack: "Ad",
    //     emphasis: {
    //       focus: "series",
    //     },
    //     data: canceledData,
    //   },
    //   {
    //     name: "Progress",
    //     type: "bar",
    //     stack: "Ad",
    //     emphasis: {
    //       focus: "series",
    //     },
    //     data: progressData,
    //   },
    //   {
    //     name: "Pending",
    //     type: "bar",
    //     stack: "Ad",
    //     emphasis: {
    //       focus: "series",
    //     },
    //     data: pendingData,
    //   },
    // ],
  };
};

export const dummyoption = {
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: [
      '11-Dec-2024',
      '10-Dec-2024',
      '19-Nov-2024',
      '15-Nov-2024',
      '1-Nov-2024',
      '23-Oct-2024',
      '25-Oct-2024',
      '18-Oct-2024',
      '21-Oct-2024',
      '11-Oct-2024',
      '12-Oct-2024',
      '21-Aug-2024',
      '17-Aug-2024',
      '10-Aug-2024',
      '8-Aug-2024',
      '14-Aug-2024',
    ],
  },
  yAxis: {
    type: 'value',
  },
  series: [
    {
      data: [2, 3, 3, 1, 2, 1, 1, 1, 1, 3, 1, 2, 2, 1, 4, 4],
      type: 'line',
      areaStyle: {},
    },
  ],
};

export const cardData = [
  {
    id: 'totalOrder',
    isSelected: false,
    title: 'Total Order',
    amount: '80',
  },
  {
    id: 'totalSells',
    isSelected: false,
    title: 'Total Sales',
    amount: '$1,200',
  },
  {
    id: 'totalPayout',
    isSelected: false,
    title: 'Total Payout',
    amount: '8,430',
  },
  {
    id: 'totalOrderCompleted',
    isSelected: false,
    title: 'Total Completed Order',
    amount: '60',
  },
  {
    id: 'all_reg_user_cnt',
    isSelected: false,
    title: 'Registered Users',
    amount: '60',
  },
  {
    id: 'all_providers_cnt',
    isSelected: false,
    title: 'Total Providers',
    amount: '60',
  },
  {
    id: 'all_users_cnt',
    isSelected: false,
    title: 'Total Users',
    amount: '60',
  },
  {
    id: 'total_users_with_profile',
    isSelected: false,
    title: 'Total Users With Profile',
    amount: '60',
  },
];

const cardKeysToDisplay = {
  userDetails: [
    {
      mapping: 'totalOrder',
      title: 'Total Order',
    },
    {
      mapping: 'totalSells',
      title: 'Total Sales',
    },
    {
      mapping: 'totalPayout',
      title: 'Total Payout',
    },
    {
      mapping: 'totalOrderCompleted',
      title: 'Total Completed Order',
    },
  ],
  totalUsersDetails: [
    {
      mapping: 'all_reg_user_cnt',
      title: 'Registered Users',
    },
    {
      mapping: 'all_providers_cnt',
      title: 'Total Providers',
    },
    {
      mapping: 'all_users_cnt',
      title: 'Total Users',
    },
    {
      mapping: 'total_users_with_profile',
      title: 'Total Users With Profile',
    },
  ],
};

export function UpdateCardData(
  filterOrders,
  setCardDatas,
  selectedDuration,
  totalUsersData
) {
  // *****************************  Order by Date and Status  Start*****************************
  const orderStatusByDate = filterOrders?.reduce((acc, order) => {
    const date = order.ord_svc_date;
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(order);
    return acc;
  }, {});

  const orderStatusChartByDate = Object.keys(orderStatusByDate)?.map((date) => {
    const orders = orderStatusByDate[date];
    const submittedCount = orders?.reduce(
      (count, order) =>
        Number(order.order_status_id) === 7 ? count + 1 : count,
      0
    );
    return {
      date,
      COMPLETED: submittedCount,
    };
  });
  const orderSubmitted = orderStatusChartByDate?.map(
    (order) => order?.COMPLETED
  );
  const totalOrderCompleted = orderSubmitted?.reduce(
    (acc, item) => acc + item,
    0
  );

  // *****************************  Order by Date and Status  End *****************************

  // *****************************  Order by Date Start *****************************
  const totalOrdersByDate = filterOrders?.reduce((acc, order) => {
    const date = order.ord_svc_date;
    if (acc[date]) {
      acc[date] += 1;
    } else {
      acc[date] = 1;
    }
    return acc;
  }, {});

  const totalOrdersChartDataValue = Object.values(totalOrdersByDate);
  const totalOrder = totalOrdersChartDataValue?.reduce(
    (acc, item) => acc + item,
    0
  );

  // *****************************  Order by Date End *****************************
  // *****************************  Payout by Date Start *****************************

  const dateCountsByPayout = filterOrders?.reduce((acc, data) => {
    const amount = data?.svc_provider_cost_amt;
    const date = data?.ord_svc_date_orig;
    if (acc[date]) {
      acc[date] += Number(amount);
    } else {
      acc[date] = Number(amount);
    }
    return acc;
  }, {});

  const PayoutChartDataValue = Object.values(dateCountsByPayout);

  const totalPayout = PayoutChartDataValue?.reduce(
    (acc, item) => acc + item,
    0
  );

  // *****************************  Payout by Date End *****************************

  // *****************************  Sell by Date Start *****************************

  const sellCostChartData = Object.keys(orderStatusByDate)?.map((date) => {
    const orders = orderStatusByDate[date];
    const totalSales = orders?.reduce(
      (acc, order) => acc + Number(order?.order_tot_amt),
      0
    );
    return {
      date,
      sell: totalSales,
    };
  });
  const sellCostChartDataValue = sellCostChartData?.map((item) => item?.sell);
  const totalSells = sellCostChartDataValue?.reduce(
    (acc, value) => acc + value,
    0
  );

  const mappingData = {
    totalOrder,
    totalPayout,
    totalSells,
    totalOrderCompleted,
  };

  const userDetailsCards = cardKeysToDisplay.userDetails?.map((card) => {
    return {
      ...card,
      amount: amountFormat(mappingData[card.mapping]),
      id: card.mapping,
      isSelected: false,
      title: card.title,
    };
  });
  const userDetailCards = cardKeysToDisplay.totalUsersDetails?.map((card) => {
    return {
      ...card,
      amount: amountFormat(totalUsersData[card.mapping]),
      id: card.mapping,
      isSelected: false,
      title: card.title,
    };
  });
  setCardDatas([...userDetailsCards, ...userDetailCards]);

  // *****************************  Payout by Date End *****************************
}

export const getFilteredOrders = (duration, orders) => {
  const today = dayjs();
  let startDate;

  if (duration === 'week') {
    startDate = today.subtract(7, 'day');
  } else if (duration === 'month') {
    startDate = today.subtract(1, 'month');
  } else if (duration === 'year') {
    startDate = today.subtract(1, 'year');
  } else {
    return orders;
  }

  const filteredOrders = orders?.filter((order) => {
    const orderDate = dayjs(order?.ord_svc_date);
    return (
      (orderDate.isAfter(startDate) && orderDate.isBefore(today)) ||
      orderDate.isSame(startDate) ||
      orderDate.isSame(today)
    );
  });

  return filteredOrders;
};

export const dummyData = {
  '11-Dec-2024': [
    {
      order_id: 421,
      order_status_id: 1,
      s_status_cd: 'SUBMITTED',
      s_status_desc: 'Order Submitted',
      user_first_name: 'Cosmas',
      user_last_name: 'Majachani',
      svc_name: 'Pharmacy Prescription',
      svc_price_amt: '0.00',
      order_tot_amt: '0.00',
      sys_crte_tsp: '2024-12-10 05:14:30',
    },
    {
      order_id: 422,
      order_status_id: 2,
      s_status_cd: 'IN_PROGRESS',
      s_status_desc: 'Order In Progress',
      user_first_name: 'John',
      user_last_name: 'Doe',
      svc_name: 'Dental Checkup',
      svc_price_amt: '20.00',
      order_tot_amt: '20.00',
      sys_crte_tsp: '2024-12-10 06:30:00',
    },
    {
      order_id: 423,
      order_status_id: 3,
      s_status_cd: 'AWAITING_PAYMENT',
      s_status_desc: 'Awaiting Payment',
      user_first_name: 'Jane',
      user_last_name: 'Smith',
      svc_name: 'Vision Test',
      svc_price_amt: '15.00',
      order_tot_amt: '15.00',
      sys_crte_tsp: '2024-12-10 07:00:00',
    },
    {
      order_id: 424,
      order_status_id: 4,
      s_status_cd: 'PAID',
      s_status_desc: 'Order Paid',
      user_first_name: 'Alice',
      user_last_name: 'Brown',
      svc_name: 'Blood Test',
      svc_price_amt: '25.00',
      order_tot_amt: '25.00',
      sys_crte_tsp: '2024-12-10 08:00:00',
    },
    {
      order_id: 425,
      order_status_id: 5,
      s_status_cd: 'DISPATCHED',
      s_status_desc: 'Order Dispatched',
      user_first_name: 'Michael',
      user_last_name: 'Johnson',
      svc_name: 'General Consultation',
      svc_price_amt: '10.00',
      order_tot_amt: '10.00',
      sys_crte_tsp: '2024-12-10 09:00:00',
    },
    {
      order_id: 426,
      order_status_id: 6,
      s_status_cd: 'DELIVERED',
      s_status_desc: 'Order Delivered',
      user_first_name: 'Emily',
      user_last_name: 'Clark',
      svc_name: 'Physical Therapy',
      svc_price_amt: '30.00',
      order_tot_amt: '30.00',
      sys_crte_tsp: '2024-12-10 10:00:00',
    },
    {
      order_id: 427,
      order_status_id: 7,
      s_status_cd: 'CANCELLED',
      s_status_desc: 'Order Cancelled',
      user_first_name: 'Daniel',
      user_last_name: 'White',
      svc_name: 'Health Checkup',
      svc_price_amt: '50.00',
      order_tot_amt: '50.00',
      sys_crte_tsp: '2024-12-10 11:00:00',
    },
    {
      order_id: 428,
      order_status_id: 8,
      s_status_cd: 'REFUNDED',
      s_status_desc: 'Order Refunded',
      user_first_name: 'Sophia',
      user_last_name: 'Miller',
      svc_name: 'Vaccination',
      svc_price_amt: '20.00',
      order_tot_amt: '20.00',
      sys_crte_tsp: '2024-12-10 12:00:00',
    },
    {
      order_id: 429,
      order_status_id: 9,
      s_status_cd: 'ON_HOLD',
      s_status_desc: 'Order On Hold',
      user_first_name: 'Liam',
      user_last_name: 'Anderson',
      svc_name: 'X-Ray',
      svc_price_amt: '40.00',
      order_tot_amt: '40.00',
      sys_crte_tsp: '2024-12-10 13:00:00',
    },
    {
      order_id: 430,
      order_status_id: 10,
      s_status_cd: 'COMPLETED',
      s_status_desc: 'Order Completed',
      user_first_name: 'Isabella',
      user_last_name: 'Garcia',
      svc_name: 'Ultrasound',
      svc_price_amt: '70.00',
      order_tot_amt: '70.00',
      sys_crte_tsp: '2024-12-10 14:00:00',
    },
    {
      order_id: 431,
      order_status_id: 11,
      s_status_cd: 'FAILED',
      s_status_desc: 'Order Failed',
      user_first_name: 'Ethan',
      user_last_name: 'Martinez',
      svc_name: 'MRI Scan',
      svc_price_amt: '100.00',
      order_tot_amt: '100.00',
      sys_crte_tsp: '2024-12-10 15:00:00',
    },
    {
      order_id: 432,
      order_status_id: 12,
      s_status_cd: 'PENDING_APPROVAL',
      s_status_desc: 'Pending Approval',
      user_first_name: 'Charlotte',
      user_last_name: 'Lee',
      svc_name: 'Lab Tests',
      svc_price_amt: '35.00',
      order_tot_amt: '35.00',
      sys_crte_tsp: '2024-12-10 16:00:00',
    },
    {
      order_id: 433,
      order_status_id: 13,
      s_status_cd: 'EXPIRED',
      s_status_desc: 'Order Expired',
      user_first_name: 'Mason',
      user_last_name: 'Kim',
      svc_name: 'Physiotherapy',
      svc_price_amt: '25.00',
      order_tot_amt: '25.00',
      sys_crte_tsp: '2024-12-10 17:00:00',
    },
    {
      order_id: 434,
      order_status_id: 14,
      s_status_cd: 'REJECTED',
      s_status_desc: 'Order Rejected',
      user_first_name: 'Amelia',
      user_last_name: 'Brown',
      svc_name: 'Consultation',
      svc_price_amt: '12.00',
      order_tot_amt: '12.00',
      sys_crte_tsp: '2024-12-10 18:00:00',
    },
  ],
  '15-Dec-2024': [
    {
      order_id: 421,
      order_status_id: 1,
      s_status_cd: 'SUBMITTED',
      s_status_desc: 'Order Submitted',
      user_first_name: 'Cosmas',
      user_last_name: 'Majachani',
      svc_name: 'Pharmacy Prescription',
      svc_price_amt: '0.00',
      order_tot_amt: '0.00',
      sys_crte_tsp: '2024-12-10 05:14:30',
    },
    {
      order_id: 422,
      order_status_id: 2,
      s_status_cd: 'IN_PROGRESS',
      s_status_desc: 'Order In Progress',
      user_first_name: 'John',
      user_last_name: 'Doe',
      svc_name: 'Dental Checkup',
      svc_price_amt: '20.00',
      order_tot_amt: '20.00',
      sys_crte_tsp: '2024-12-10 06:30:00',
    },
    {
      order_id: 423,
      order_status_id: 3,
      s_status_cd: 'AWAITING_PAYMENT',
      s_status_desc: 'Awaiting Payment',
      user_first_name: 'Jane',
      user_last_name: 'Smith',
      svc_name: 'Vision Test',
      svc_price_amt: '15.00',
      order_tot_amt: '15.00',
      sys_crte_tsp: '2024-12-10 07:00:00',
    },
    {
      order_id: 424,
      order_status_id: 4,
      s_status_cd: 'PAID',
      s_status_desc: 'Order Paid',
      user_first_name: 'Alice',
      user_last_name: 'Brown',
      svc_name: 'Blood Test',
      svc_price_amt: '25.00',
      order_tot_amt: '25.00',
      sys_crte_tsp: '2024-12-10 08:00:00',
    },
    {
      order_id: 425,
      order_status_id: 5,
      s_status_cd: 'DISPATCHED',
      s_status_desc: 'Order Dispatched',
      user_first_name: 'Michael',
      user_last_name: 'Johnson',
      svc_name: 'General Consultation',
      svc_price_amt: '10.00',
      order_tot_amt: '10.00',
      sys_crte_tsp: '2024-12-10 09:00:00',
    },
    {
      order_id: 426,
      order_status_id: 6,
      s_status_cd: 'DELIVERED',
      s_status_desc: 'Order Delivered',
      user_first_name: 'Emily',
      user_last_name: 'Clark',
      svc_name: 'Physical Therapy',
      svc_price_amt: '30.00',
      order_tot_amt: '30.00',
      sys_crte_tsp: '2024-12-10 10:00:00',
    },
    {
      order_id: 427,
      order_status_id: 7,
      s_status_cd: 'CANCELLED',
      s_status_desc: 'Order Cancelled',
      user_first_name: 'Daniel',
      user_last_name: 'White',
      svc_name: 'Health Checkup',
      svc_price_amt: '50.00',
      order_tot_amt: '50.00',
      sys_crte_tsp: '2024-12-10 11:00:00',
    },
    {
      order_id: 428,
      order_status_id: 8,
      s_status_cd: 'REFUNDED',
      s_status_desc: 'Order Refunded',
      user_first_name: 'Sophia',
      user_last_name: 'Miller',
      svc_name: 'Vaccination',
      svc_price_amt: '20.00',
      order_tot_amt: '20.00',
      sys_crte_tsp: '2024-12-10 12:00:00',
    },
    {
      order_id: 429,
      order_status_id: 9,
      s_status_cd: 'ON_HOLD',
      s_status_desc: 'Order On Hold',
      user_first_name: 'Liam',
      user_last_name: 'Anderson',
      svc_name: 'X-Ray',
      svc_price_amt: '40.00',
      order_tot_amt: '40.00',
      sys_crte_tsp: '2024-12-10 13:00:00',
    },
    {
      order_id: 430,
      order_status_id: 10,
      s_status_cd: 'COMPLETED',
      s_status_desc: 'Order Completed',
      user_first_name: 'Isabella',
      user_last_name: 'Garcia',
      svc_name: 'Ultrasound',
      svc_price_amt: '70.00',
      order_tot_amt: '70.00',
      sys_crte_tsp: '2024-12-10 14:00:00',
    },
    {
      order_id: 431,
      order_status_id: 11,
      s_status_cd: 'FAILED',
      s_status_desc: 'Order Failed',
      user_first_name: 'Ethan',
      user_last_name: 'Martinez',
      svc_name: 'MRI Scan',
      svc_price_amt: '100.00',
      order_tot_amt: '100.00',
      sys_crte_tsp: '2024-12-10 15:00:00',
    },
    {
      order_id: 432,
      order_status_id: 12,
      s_status_cd: 'PENDING_APPROVAL',
      s_status_desc: 'Pending Approval',
      user_first_name: 'Charlotte',
      user_last_name: 'Lee',
      svc_name: 'Lab Tests',
      svc_price_amt: '35.00',
      order_tot_amt: '35.00',
      sys_crte_tsp: '2024-12-10 16:00:00',
    },
    {
      order_id: 433,
      order_status_id: 13,
      s_status_cd: 'EXPIRED',
      s_status_desc: 'Order Expired',
      user_first_name: 'Mason',
      user_last_name: 'Kim',
      svc_name: 'Physiotherapy',
      svc_price_amt: '25.00',
      order_tot_amt: '25.00',
      sys_crte_tsp: '2024-12-10 17:00:00',
    },
    {
      order_id: 434,
      order_status_id: 14,
      s_status_cd: 'REJECTED',
      s_status_desc: 'Order Rejected',
      user_first_name: 'Amelia',
      user_last_name: 'Brown',
      svc_name: 'Consultation',
      svc_price_amt: '12.00',
      order_tot_amt: '12.00',
      sys_crte_tsp: '2024-12-10 18:00:00',
    },
  ],
  '18-Dec-2024': [
    {
      order_id: 421,
      order_status_id: 1,
      s_status_cd: 'SUBMITTED',
      s_status_desc: 'Order Submitted',
      user_first_name: 'Cosmas',
      user_last_name: 'Majachani',
      svc_name: 'Pharmacy Prescription',
      svc_price_amt: '0.00',
      order_tot_amt: '0.00',
      sys_crte_tsp: '2024-12-10 05:14:30',
    },
    {
      order_id: 422,
      order_status_id: 2,
      s_status_cd: 'IN_PROGRESS',
      s_status_desc: 'Order In Progress',
      user_first_name: 'John',
      user_last_name: 'Doe',
      svc_name: 'Dental Checkup',
      svc_price_amt: '20.00',
      order_tot_amt: '20.00',
      sys_crte_tsp: '2024-12-10 06:30:00',
    },
    {
      order_id: 423,
      order_status_id: 3,
      s_status_cd: 'AWAITING_PAYMENT',
      s_status_desc: 'Awaiting Payment',
      user_first_name: 'Jane',
      user_last_name: 'Smith',
      svc_name: 'Vision Test',
      svc_price_amt: '15.00',
      order_tot_amt: '15.00',
      sys_crte_tsp: '2024-12-10 07:00:00',
    },
    {
      order_id: 424,
      order_status_id: 4,
      s_status_cd: 'PAID',
      s_status_desc: 'Order Paid',
      user_first_name: 'Alice',
      user_last_name: 'Brown',
      svc_name: 'Blood Test',
      svc_price_amt: '25.00',
      order_tot_amt: '25.00',
      sys_crte_tsp: '2024-12-10 08:00:00',
    },
    {
      order_id: 425,
      order_status_id: 5,
      s_status_cd: 'DISPATCHED',
      s_status_desc: 'Order Dispatched',
      user_first_name: 'Michael',
      user_last_name: 'Johnson',
      svc_name: 'General Consultation',
      svc_price_amt: '10.00',
      order_tot_amt: '10.00',
      sys_crte_tsp: '2024-12-10 09:00:00',
    },
    {
      order_id: 426,
      order_status_id: 6,
      s_status_cd: 'DELIVERED',
      s_status_desc: 'Order Delivered',
      user_first_name: 'Emily',
      user_last_name: 'Clark',
      svc_name: 'Physical Therapy',
      svc_price_amt: '30.00',
      order_tot_amt: '30.00',
      sys_crte_tsp: '2024-12-10 10:00:00',
    },
    {
      order_id: 427,
      order_status_id: 7,
      s_status_cd: 'CANCELLED',
      s_status_desc: 'Order Cancelled',
      user_first_name: 'Daniel',
      user_last_name: 'White',
      svc_name: 'Health Checkup',
      svc_price_amt: '50.00',
      order_tot_amt: '50.00',
      sys_crte_tsp: '2024-12-10 11:00:00',
    },
    {
      order_id: 428,
      order_status_id: 8,
      s_status_cd: 'REFUNDED',
      s_status_desc: 'Order Refunded',
      user_first_name: 'Sophia',
      user_last_name: 'Miller',
      svc_name: 'Vaccination',
      svc_price_amt: '20.00',
      order_tot_amt: '20.00',
      sys_crte_tsp: '2024-12-10 12:00:00',
    },
    {
      order_id: 429,
      order_status_id: 9,
      s_status_cd: 'ON_HOLD',
      s_status_desc: 'Order On Hold',
      user_first_name: 'Liam',
      user_last_name: 'Anderson',
      svc_name: 'X-Ray',
      svc_price_amt: '40.00',
      order_tot_amt: '40.00',
      sys_crte_tsp: '2024-12-10 13:00:00',
    },
    {
      order_id: 430,
      order_status_id: 10,
      s_status_cd: 'COMPLETED',
      s_status_desc: 'Order Completed',
      user_first_name: 'Isabella',
      user_last_name: 'Garcia',
      svc_name: 'Ultrasound',
      svc_price_amt: '70.00',
      order_tot_amt: '70.00',
      sys_crte_tsp: '2024-12-10 14:00:00',
    },
    {
      order_id: 431,
      order_status_id: 11,
      s_status_cd: 'FAILED',
      s_status_desc: 'Order Failed',
      user_first_name: 'Ethan',
      user_last_name: 'Martinez',
      svc_name: 'MRI Scan',
      svc_price_amt: '100.00',
      order_tot_amt: '100.00',
      sys_crte_tsp: '2024-12-10 15:00:00',
    },
    {
      order_id: 432,
      order_status_id: 12,
      s_status_cd: 'PENDING_APPROVAL',
      s_status_desc: 'Pending Approval',
      user_first_name: 'Charlotte',
      user_last_name: 'Lee',
      svc_name: 'Lab Tests',
      svc_price_amt: '35.00',
      order_tot_amt: '35.00',
      sys_crte_tsp: '2024-12-10 16:00:00',
    },
    {
      order_id: 433,
      order_status_id: 13,
      s_status_cd: 'EXPIRED',
      s_status_desc: 'Order Expired',
      user_first_name: 'Mason',
      user_last_name: 'Kim',
      svc_name: 'Physiotherapy',
      svc_price_amt: '25.00',
      order_tot_amt: '25.00',
      sys_crte_tsp: '2024-12-10 17:00:00',
    },
    {
      order_id: 434,
      order_status_id: 14,
      s_status_cd: 'REJECTED',
      s_status_desc: 'Order Rejected',
      user_first_name: 'Amelia',
      user_last_name: 'Brown',
      svc_name: 'Consultation',
      svc_price_amt: '12.00',
      order_tot_amt: '12.00',
      sys_crte_tsp: '2024-12-10 18:00:00',
    },
  ],
  '21-Jan-2025': [
    {
      order_id: 421,
      order_status_id: 1,
      s_status_cd: 'SUBMITTED',
      s_status_desc: 'Order Submitted',
      user_first_name: 'Cosmas',
      user_last_name: 'Majachani',
      svc_name: 'Pharmacy Prescription',
      svc_price_amt: '0.00',
      order_tot_amt: '0.00',
      sys_crte_tsp: '2024-12-10 05:14:30',
    },
    {
      order_id: 422,
      order_status_id: 2,
      s_status_cd: 'IN_PROGRESS',
      s_status_desc: 'Order In Progress',
      user_first_name: 'John',
      user_last_name: 'Doe',
      svc_name: 'Dental Checkup',
      svc_price_amt: '20.00',
      order_tot_amt: '20.00',
      sys_crte_tsp: '2024-12-10 06:30:00',
    },
    {
      order_id: 423,
      order_status_id: 3,
      s_status_cd: 'AWAITING_PAYMENT',
      s_status_desc: 'Awaiting Payment',
      user_first_name: 'Jane',
      user_last_name: 'Smith',
      svc_name: 'Vision Test',
      svc_price_amt: '15.00',
      order_tot_amt: '15.00',
      sys_crte_tsp: '2024-12-10 07:00:00',
    },
    {
      order_id: 424,
      order_status_id: 4,
      s_status_cd: 'PAID',
      s_status_desc: 'Order Paid',
      user_first_name: 'Alice',
      user_last_name: 'Brown',
      svc_name: 'Blood Test',
      svc_price_amt: '25.00',
      order_tot_amt: '25.00',
      sys_crte_tsp: '2024-12-10 08:00:00',
    },
    {
      order_id: 425,
      order_status_id: 5,
      s_status_cd: 'DISPATCHED',
      s_status_desc: 'Order Dispatched',
      user_first_name: 'Michael',
      user_last_name: 'Johnson',
      svc_name: 'General Consultation',
      svc_price_amt: '10.00',
      order_tot_amt: '10.00',
      sys_crte_tsp: '2024-12-10 09:00:00',
    },
    {
      order_id: 426,
      order_status_id: 6,
      s_status_cd: 'DELIVERED',
      s_status_desc: 'Order Delivered',
      user_first_name: 'Emily',
      user_last_name: 'Clark',
      svc_name: 'Physical Therapy',
      svc_price_amt: '30.00',
      order_tot_amt: '30.00',
      sys_crte_tsp: '2024-12-10 10:00:00',
    },
    {
      order_id: 427,
      order_status_id: 7,
      s_status_cd: 'CANCELLED',
      s_status_desc: 'Order Cancelled',
      user_first_name: 'Daniel',
      user_last_name: 'White',
      svc_name: 'Health Checkup',
      svc_price_amt: '50.00',
      order_tot_amt: '50.00',
      sys_crte_tsp: '2024-12-10 11:00:00',
    },
    {
      order_id: 428,
      order_status_id: 8,
      s_status_cd: 'REFUNDED',
      s_status_desc: 'Order Refunded',
      user_first_name: 'Sophia',
      user_last_name: 'Miller',
      svc_name: 'Vaccination',
      svc_price_amt: '20.00',
      order_tot_amt: '20.00',
      sys_crte_tsp: '2024-12-10 12:00:00',
    },
    {
      order_id: 429,
      order_status_id: 9,
      s_status_cd: 'ON_HOLD',
      s_status_desc: 'Order On Hold',
      user_first_name: 'Liam',
      user_last_name: 'Anderson',
      svc_name: 'X-Ray',
      svc_price_amt: '40.00',
      order_tot_amt: '40.00',
      sys_crte_tsp: '2024-12-10 13:00:00',
    },
    {
      order_id: 430,
      order_status_id: 10,
      s_status_cd: 'COMPLETED',
      s_status_desc: 'Order Completed',
      user_first_name: 'Isabella',
      user_last_name: 'Garcia',
      svc_name: 'Ultrasound',
      svc_price_amt: '70.00',
      order_tot_amt: '70.00',
      sys_crte_tsp: '2024-12-10 14:00:00',
    },
    {
      order_id: 431,
      order_status_id: 11,
      s_status_cd: 'FAILED',
      s_status_desc: 'Order Failed',
      user_first_name: 'Ethan',
      user_last_name: 'Martinez',
      svc_name: 'MRI Scan',
      svc_price_amt: '100.00',
      order_tot_amt: '100.00',
      sys_crte_tsp: '2024-12-10 15:00:00',
    },
    {
      order_id: 432,
      order_status_id: 12,
      s_status_cd: 'PENDING_APPROVAL',
      s_status_desc: 'Pending Approval',
      user_first_name: 'Charlotte',
      user_last_name: 'Lee',
      svc_name: 'Lab Tests',
      svc_price_amt: '35.00',
      order_tot_amt: '35.00',
      sys_crte_tsp: '2024-12-10 16:00:00',
    },
    {
      order_id: 433,
      order_status_id: 13,
      s_status_cd: 'EXPIRED',
      s_status_desc: 'Order Expired',
      user_first_name: 'Mason',
      user_last_name: 'Kim',
      svc_name: 'Physiotherapy',
      svc_price_amt: '25.00',
      order_tot_amt: '25.00',
      sys_crte_tsp: '2024-12-10 17:00:00',
    },
    {
      order_id: 434,
      order_status_id: 14,
      s_status_cd: 'REJECTED',
      s_status_desc: 'Order Rejected',
      user_first_name: 'Amelia',
      user_last_name: 'Brown',
      svc_name: 'Consultation',
      svc_price_amt: '12.00',
      order_tot_amt: '12.00',
      sys_crte_tsp: '2024-12-10 18:00:00',
    },
  ],
  '16-feb-2025': [
    {
      order_id: 421,
      order_status_id: 1,
      s_status_cd: 'SUBMITTED',
      s_status_desc: 'Order Submitted',
      user_first_name: 'Cosmas',
      user_last_name: 'Majachani',
      svc_name: 'Pharmacy Prescription',
      svc_price_amt: '0.00',
      order_tot_amt: '0.00',
      sys_crte_tsp: '2024-12-10 05:14:30',
    },
    {
      order_id: 422,
      order_status_id: 2,
      s_status_cd: 'IN_PROGRESS',
      s_status_desc: 'Order In Progress',
      user_first_name: 'John',
      user_last_name: 'Doe',
      svc_name: 'Dental Checkup',
      svc_price_amt: '20.00',
      order_tot_amt: '20.00',
      sys_crte_tsp: '2024-12-10 06:30:00',
    },
    {
      order_id: 423,
      order_status_id: 3,
      s_status_cd: 'AWAITING_PAYMENT',
      s_status_desc: 'Awaiting Payment',
      user_first_name: 'Jane',
      user_last_name: 'Smith',
      svc_name: 'Vision Test',
      svc_price_amt: '15.00',
      order_tot_amt: '15.00',
      sys_crte_tsp: '2024-12-10 07:00:00',
    },
    {
      order_id: 424,
      order_status_id: 4,
      s_status_cd: 'PAID',
      s_status_desc: 'Order Paid',
      user_first_name: 'Alice',
      user_last_name: 'Brown',
      svc_name: 'Blood Test',
      svc_price_amt: '25.00',
      order_tot_amt: '25.00',
      sys_crte_tsp: '2024-12-10 08:00:00',
    },
    {
      order_id: 425,
      order_status_id: 5,
      s_status_cd: 'DISPATCHED',
      s_status_desc: 'Order Dispatched',
      user_first_name: 'Michael',
      user_last_name: 'Johnson',
      svc_name: 'General Consultation',
      svc_price_amt: '10.00',
      order_tot_amt: '10.00',
      sys_crte_tsp: '2024-12-10 09:00:00',
    },
    {
      order_id: 426,
      order_status_id: 6,
      s_status_cd: 'DELIVERED',
      s_status_desc: 'Order Delivered',
      user_first_name: 'Emily',
      user_last_name: 'Clark',
      svc_name: 'Physical Therapy',
      svc_price_amt: '30.00',
      order_tot_amt: '30.00',
      sys_crte_tsp: '2024-12-10 10:00:00',
    },
    {
      order_id: 427,
      order_status_id: 7,
      s_status_cd: 'CANCELLED',
      s_status_desc: 'Order Cancelled',
      user_first_name: 'Daniel',
      user_last_name: 'White',
      svc_name: 'Health Checkup',
      svc_price_amt: '50.00',
      order_tot_amt: '50.00',
      sys_crte_tsp: '2024-12-10 11:00:00',
    },
    {
      order_id: 428,
      order_status_id: 8,
      s_status_cd: 'REFUNDED',
      s_status_desc: 'Order Refunded',
      user_first_name: 'Sophia',
      user_last_name: 'Miller',
      svc_name: 'Vaccination',
      svc_price_amt: '20.00',
      order_tot_amt: '20.00',
      sys_crte_tsp: '2024-12-10 12:00:00',
    },
    {
      order_id: 429,
      order_status_id: 9,
      s_status_cd: 'ON_HOLD',
      s_status_desc: 'Order On Hold',
      user_first_name: 'Liam',
      user_last_name: 'Anderson',
      svc_name: 'X-Ray',
      svc_price_amt: '40.00',
      order_tot_amt: '40.00',
      sys_crte_tsp: '2024-12-10 13:00:00',
    },
    {
      order_id: 430,
      order_status_id: 10,
      s_status_cd: 'COMPLETED',
      s_status_desc: 'Order Completed',
      user_first_name: 'Isabella',
      user_last_name: 'Garcia',
      svc_name: 'Ultrasound',
      svc_price_amt: '70.00',
      order_tot_amt: '70.00',
      sys_crte_tsp: '2024-12-10 14:00:00',
    },
    {
      order_id: 431,
      order_status_id: 11,
      s_status_cd: 'FAILED',
      s_status_desc: 'Order Failed',
      user_first_name: 'Ethan',
      user_last_name: 'Martinez',
      svc_name: 'MRI Scan',
      svc_price_amt: '100.00',
      order_tot_amt: '100.00',
      sys_crte_tsp: '2024-12-10 15:00:00',
    },
    {
      order_id: 432,
      order_status_id: 12,
      s_status_cd: 'PENDING_APPROVAL',
      s_status_desc: 'Pending Approval',
      user_first_name: 'Charlotte',
      user_last_name: 'Lee',
      svc_name: 'Lab Tests',
      svc_price_amt: '35.00',
      order_tot_amt: '35.00',
      sys_crte_tsp: '2024-12-10 16:00:00',
    },
    {
      order_id: 433,
      order_status_id: 13,
      s_status_cd: 'EXPIRED',
      s_status_desc: 'Order Expired',
      user_first_name: 'Mason',
      user_last_name: 'Kim',
      svc_name: 'Physiotherapy',
      svc_price_amt: '25.00',
      order_tot_amt: '25.00',
      sys_crte_tsp: '2024-12-10 17:00:00',
    },
    {
      order_id: 434,
      order_status_id: 14,
      s_status_cd: 'REJECTED',
      s_status_desc: 'Order Rejected',
      user_first_name: 'Amelia',
      user_last_name: 'Brown',
      svc_name: 'Consultation',
      svc_price_amt: '12.00',
      order_tot_amt: '12.00',
      sys_crte_tsp: '2024-12-10 18:00:00',
    },
  ],
  '17-March-2025': [
    {
      order_id: 421,
      order_status_id: 1,
      s_status_cd: 'SUBMITTED',
      s_status_desc: 'Order Submitted',
      user_first_name: 'Cosmas',
      user_last_name: 'Majachani',
      svc_name: 'Pharmacy Prescription',
      svc_price_amt: '0.00',
      order_tot_amt: '0.00',
      sys_crte_tsp: '2024-12-10 05:14:30',
    },
    {
      order_id: 422,
      order_status_id: 2,
      s_status_cd: 'IN_PROGRESS',
      s_status_desc: 'Order In Progress',
      user_first_name: 'John',
      user_last_name: 'Doe',
      svc_name: 'Dental Checkup',
      svc_price_amt: '20.00',
      order_tot_amt: '20.00',
      sys_crte_tsp: '2024-12-10 06:30:00',
    },
    {
      order_id: 423,
      order_status_id: 3,
      s_status_cd: 'AWAITING_PAYMENT',
      s_status_desc: 'Awaiting Payment',
      user_first_name: 'Jane',
      user_last_name: 'Smith',
      svc_name: 'Vision Test',
      svc_price_amt: '15.00',
      order_tot_amt: '15.00',
      sys_crte_tsp: '2024-12-10 07:00:00',
    },
    {
      order_id: 424,
      order_status_id: 4,
      s_status_cd: 'PAID',
      s_status_desc: 'Order Paid',
      user_first_name: 'Alice',
      user_last_name: 'Brown',
      svc_name: 'Blood Test',
      svc_price_amt: '25.00',
      order_tot_amt: '25.00',
      sys_crte_tsp: '2024-12-10 08:00:00',
    },
    {
      order_id: 425,
      order_status_id: 5,
      s_status_cd: 'DISPATCHED',
      s_status_desc: 'Order Dispatched',
      user_first_name: 'Michael',
      user_last_name: 'Johnson',
      svc_name: 'General Consultation',
      svc_price_amt: '10.00',
      order_tot_amt: '10.00',
      sys_crte_tsp: '2024-12-10 09:00:00',
    },
    {
      order_id: 426,
      order_status_id: 6,
      s_status_cd: 'DELIVERED',
      s_status_desc: 'Order Delivered',
      user_first_name: 'Emily',
      user_last_name: 'Clark',
      svc_name: 'Physical Therapy',
      svc_price_amt: '30.00',
      order_tot_amt: '30.00',
      sys_crte_tsp: '2024-12-10 10:00:00',
    },
    {
      order_id: 427,
      order_status_id: 7,
      s_status_cd: 'CANCELLED',
      s_status_desc: 'Order Cancelled',
      user_first_name: 'Daniel',
      user_last_name: 'White',
      svc_name: 'Health Checkup',
      svc_price_amt: '50.00',
      order_tot_amt: '50.00',
      sys_crte_tsp: '2024-12-10 11:00:00',
    },
    {
      order_id: 428,
      order_status_id: 8,
      s_status_cd: 'REFUNDED',
      s_status_desc: 'Order Refunded',
      user_first_name: 'Sophia',
      user_last_name: 'Miller',
      svc_name: 'Vaccination',
      svc_price_amt: '20.00',
      order_tot_amt: '20.00',
      sys_crte_tsp: '2024-12-10 12:00:00',
    },
    {
      order_id: 429,
      order_status_id: 9,
      s_status_cd: 'ON_HOLD',
      s_status_desc: 'Order On Hold',
      user_first_name: 'Liam',
      user_last_name: 'Anderson',
      svc_name: 'X-Ray',
      svc_price_amt: '40.00',
      order_tot_amt: '40.00',
      sys_crte_tsp: '2024-12-10 13:00:00',
    },
    {
      order_id: 430,
      order_status_id: 10,
      s_status_cd: 'COMPLETED',
      s_status_desc: 'Order Completed',
      user_first_name: 'Isabella',
      user_last_name: 'Garcia',
      svc_name: 'Ultrasound',
      svc_price_amt: '70.00',
      order_tot_amt: '70.00',
      sys_crte_tsp: '2024-12-10 14:00:00',
    },
    {
      order_id: 431,
      order_status_id: 11,
      s_status_cd: 'FAILED',
      s_status_desc: 'Order Failed',
      user_first_name: 'Ethan',
      user_last_name: 'Martinez',
      svc_name: 'MRI Scan',
      svc_price_amt: '100.00',
      order_tot_amt: '100.00',
      sys_crte_tsp: '2024-12-10 15:00:00',
    },
    {
      order_id: 432,
      order_status_id: 12,
      s_status_cd: 'PENDING_APPROVAL',
      s_status_desc: 'Pending Approval',
      user_first_name: 'Charlotte',
      user_last_name: 'Lee',
      svc_name: 'Lab Tests',
      svc_price_amt: '35.00',
      order_tot_amt: '35.00',
      sys_crte_tsp: '2024-12-10 16:00:00',
    },
    {
      order_id: 433,
      order_status_id: 13,
      s_status_cd: 'EXPIRED',
      s_status_desc: 'Order Expired',
      user_first_name: 'Mason',
      user_last_name: 'Kim',
      svc_name: 'Physiotherapy',
      svc_price_amt: '25.00',
      order_tot_amt: '25.00',
      sys_crte_tsp: '2024-12-10 17:00:00',
    },
    {
      order_id: 434,
      order_status_id: 14,
      s_status_cd: 'REJECTED',
      s_status_desc: 'Order Rejected',
      user_first_name: 'Amelia',
      user_last_name: 'Brown',
      svc_name: 'Consultation',
      svc_price_amt: '12.00',
      order_tot_amt: '12.00',
      sys_crte_tsp: '2024-12-10 18:00:00',
    },
  ],
  '18-April-2024': [
    {
      order_id: 421,
      order_status_id: 1,
      s_status_cd: 'SUBMITTED',
      s_status_desc: 'Order Submitted',
      user_first_name: 'Cosmas',
      user_last_name: 'Majachani',
      svc_name: 'Pharmacy Prescription',
      svc_price_amt: '0.00',
      order_tot_amt: '0.00',
      sys_crte_tsp: '2024-12-10 05:14:30',
    },
    {
      order_id: 422,
      order_status_id: 2,
      s_status_cd: 'IN_PROGRESS',
      s_status_desc: 'Order In Progress',
      user_first_name: 'John',
      user_last_name: 'Doe',
      svc_name: 'Dental Checkup',
      svc_price_amt: '20.00',
      order_tot_amt: '20.00',
      sys_crte_tsp: '2024-12-10 06:30:00',
    },
    {
      order_id: 423,
      order_status_id: 3,
      s_status_cd: 'AWAITING_PAYMENT',
      s_status_desc: 'Awaiting Payment',
      user_first_name: 'Jane',
      user_last_name: 'Smith',
      svc_name: 'Vision Test',
      svc_price_amt: '15.00',
      order_tot_amt: '15.00',
      sys_crte_tsp: '2024-12-10 07:00:00',
    },
    {
      order_id: 424,
      order_status_id: 4,
      s_status_cd: 'PAID',
      s_status_desc: 'Order Paid',
      user_first_name: 'Alice',
      user_last_name: 'Brown',
      svc_name: 'Blood Test',
      svc_price_amt: '25.00',
      order_tot_amt: '25.00',
      sys_crte_tsp: '2024-12-10 08:00:00',
    },
    {
      order_id: 425,
      order_status_id: 5,
      s_status_cd: 'DISPATCHED',
      s_status_desc: 'Order Dispatched',
      user_first_name: 'Michael',
      user_last_name: 'Johnson',
      svc_name: 'General Consultation',
      svc_price_amt: '10.00',
      order_tot_amt: '10.00',
      sys_crte_tsp: '2024-12-10 09:00:00',
    },
    {
      order_id: 426,
      order_status_id: 6,
      s_status_cd: 'DELIVERED',
      s_status_desc: 'Order Delivered',
      user_first_name: 'Emily',
      user_last_name: 'Clark',
      svc_name: 'Physical Therapy',
      svc_price_amt: '30.00',
      order_tot_amt: '30.00',
      sys_crte_tsp: '2024-12-10 10:00:00',
    },
    {
      order_id: 427,
      order_status_id: 7,
      s_status_cd: 'CANCELLED',
      s_status_desc: 'Order Cancelled',
      user_first_name: 'Daniel',
      user_last_name: 'White',
      svc_name: 'Health Checkup',
      svc_price_amt: '50.00',
      order_tot_amt: '50.00',
      sys_crte_tsp: '2024-12-10 11:00:00',
    },
    {
      order_id: 428,
      order_status_id: 8,
      s_status_cd: 'REFUNDED',
      s_status_desc: 'Order Refunded',
      user_first_name: 'Sophia',
      user_last_name: 'Miller',
      svc_name: 'Vaccination',
      svc_price_amt: '20.00',
      order_tot_amt: '20.00',
      sys_crte_tsp: '2024-12-10 12:00:00',
    },
    {
      order_id: 429,
      order_status_id: 9,
      s_status_cd: 'ON_HOLD',
      s_status_desc: 'Order On Hold',
      user_first_name: 'Liam',
      user_last_name: 'Anderson',
      svc_name: 'X-Ray',
      svc_price_amt: '40.00',
      order_tot_amt: '40.00',
      sys_crte_tsp: '2024-12-10 13:00:00',
    },
    {
      order_id: 430,
      order_status_id: 10,
      s_status_cd: 'COMPLETED',
      s_status_desc: 'Order Completed',
      user_first_name: 'Isabella',
      user_last_name: 'Garcia',
      svc_name: 'Ultrasound',
      svc_price_amt: '70.00',
      order_tot_amt: '70.00',
      sys_crte_tsp: '2024-12-10 14:00:00',
    },
    {
      order_id: 431,
      order_status_id: 11,
      s_status_cd: 'FAILED',
      s_status_desc: 'Order Failed',
      user_first_name: 'Ethan',
      user_last_name: 'Martinez',
      svc_name: 'MRI Scan',
      svc_price_amt: '100.00',
      order_tot_amt: '100.00',
      sys_crte_tsp: '2024-12-10 15:00:00',
    },
    {
      order_id: 432,
      order_status_id: 12,
      s_status_cd: 'PENDING_APPROVAL',
      s_status_desc: 'Pending Approval',
      user_first_name: 'Charlotte',
      user_last_name: 'Lee',
      svc_name: 'Lab Tests',
      svc_price_amt: '35.00',
      order_tot_amt: '35.00',
      sys_crte_tsp: '2024-12-10 16:00:00',
    },
    {
      order_id: 433,
      order_status_id: 13,
      s_status_cd: 'EXPIRED',
      s_status_desc: 'Order Expired',
      user_first_name: 'Mason',
      user_last_name: 'Kim',
      svc_name: 'Physiotherapy',
      svc_price_amt: '25.00',
      order_tot_amt: '25.00',
      sys_crte_tsp: '2024-12-10 17:00:00',
    },
    {
      order_id: 434,
      order_status_id: 14,
      s_status_cd: 'REJECTED',
      s_status_desc: 'Order Rejected',
      user_first_name: 'Amelia',
      user_last_name: 'Brown',
      svc_name: 'Consultation',
      svc_price_amt: '12.00',
      order_tot_amt: '12.00',
      sys_crte_tsp: '2024-12-10 18:00:00',
    },
  ],
};
